import { createFileRoute } from '@tanstack/react-router'
import { AmbientParticlesDevScreen } from '~/boggle/ui/screens/AmbientParticlesDevScreen'

export const Route = createFileRoute('/dev/particles')({
  head: () => ({
    meta: [{ title: 'Particles (dev) — Patter' }, { name: 'robots', content: 'noindex, nofollow' }],
  }),
  component: DevParticlesRoute,
})

function DevParticlesRoute() {
  return <AmbientParticlesDevScreen />
}
